import * as React from "react";

import Aside from "./Aside";
import TopBar from "./TopBar";
import { BackToTop } from "@app/shared/BackToTop";

interface LayoutState {
  showAside: boolean;
}

type LayoutProps = { children?: React.ReactNode };

export default class Layout extends React.Component<LayoutProps, LayoutState> {
  constructor(props: LayoutProps) {
    super(props);
    this.state = {
      showAside: false,
    };
  }

  public render() {
    return (
      <>
        <TopBar onHamburgerClick={this.handleHamburgerClick} showAside={this.state.showAside} />
        <Aside onHamburgerClick={this.handleHamburgerClick} showAside={this.state.showAside} />

        <main className="app-main">
          <div className="wrapper">
            {this.props.children}
          </div>
          <BackToTop />
        </main>
      </>
    );
  }

  private handleHamburgerClick = () => {
    const show = !this.state.showAside;
    this.setState({
      showAside: show,
    });

    if (!show) {
      // in case the built-in looper aside-backdrop decides to work
      document.querySelectorAll(".aside-backdrop.show").forEach((el) => el.classList.remove("show"));
    }
  }
}
